import { render, staticRenderFns } from "./schule-show.vue?vue&type=template&id=59bc0e29&"
import script from "./schule-show.vue?vue&type=script&lang=js&"
export * from "./schule-show.vue?vue&type=script&lang=js&"
import style0 from "./schule-show.vue?vue&type=style&index=0&id=59bc0e29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports